export const USERNAME_MIN_LENGTH = 5;
export const USERNAME_MAX_LENGTH = 20;

export const USERNAME_ERROR_REQUIRED = 'required';
export const USERNAME_ERROR_LENGTH = 'length';
export const USERNAME_ERROR_CHARACTERS = 'characters';

const USERNAME_ALLOWED_CHARACTERS = /^[a-z0-9_]+$/;

export const normalizeUsername = value => {
  return (value || '')
    .toString()
    .trim()
    .toLowerCase();
};

export const getUsernameFormatError = (value, { isRequired = true } = {}) => {
  const normalized = normalizeUsername(value);

  if (!normalized) {
    return isRequired ? USERNAME_ERROR_REQUIRED : null;
  }

  if (normalized.length < USERNAME_MIN_LENGTH || normalized.length > USERNAME_MAX_LENGTH) {
    return USERNAME_ERROR_LENGTH;
  }

  if (!USERNAME_ALLOWED_CHARACTERS.test(normalized)) {
    return USERNAME_ERROR_CHARACTERS;
  }

  return null;
};
